<template>
  <article class="startup-press" v-if="documents && documents.length > 0">
    <ExternalLinkButton
      :href="post.value"
      target="_blank"
      v-for="(post, i) in pressDocuments"
      :key="i"
      :icon="null"
      format="press"
      :date="Moment(post.date.date).format('D/MM/YYYY')"
      :source="post.source"
    >{{post.name}}</ExternalLinkButton>
  </article>
</template>

<script>
import Moment from 'moment';
import ExternalLinkButton from './Button/ExternalLinkButton.vue';

export default {
  name: 'StartupPress',
  components: {
    ExternalLinkButton,
  },
  props: {
    documents: Array,
  },
  computed: {
    pressDocuments(){
      return [...this.documents].sort((a, b) => {
        return Moment(b.date.date).format('x') - Moment(a.date.date).format('x');
      });
    }
  },
  data() {
    return {
      Moment,
    };
  },
};
</script>

